import 'jquery-match-height';

const $equalHeightSelector = $('.js-match-height');

if ($equalHeightSelector.length > 0) {
  $equalHeightSelector.matchHeight();
}
